import { render, staticRenderFns } from "./Aportaciones.vue?vue&type=template&id=4532709e&scoped=true&"
import script from "./Aportaciones.vue?vue&type=script&lang=js&"
export * from "./Aportaciones.vue?vue&type=script&lang=js&"
import style0 from "./Aportaciones.vue?vue&type=style&index=0&id=4532709e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4532709e",
  null
  
)

export default component.exports